module.exports = __webpack_public_path__ + "static/media/banner.c38e9e36.jpg";